import './Accessdenined.css'
export default function UnauthorizedAccess (props) {
  return <div >
     

  <div class="message">You are not authorized.
  </div>
  <div class="message2">You tried to access a page you did not have prior authorization for.</div>
  <div class="container1">
    <div class="neon">403</div>
    <div class="door-frame">
      <div class="door">
        <div class="rectangle">
      </div>
        <div class="handle">
          </div>
        <div class="window1">
          <div class="eye">
          </div>
          <div class="eye eye2">
          </div>
          <div class="leaf">
          </div> 
        </div>
      </div>  
    </div>
  </div>

    </div>
}